module.exports = __webpack_public_path__ + "static/img/userseat.8b4e139.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/userseat.png
// module id = b0B5
// module chunks = 1